import { ChevronDownIcon, ChevronRightIcon } from '@buffer-mono/popcorn'

import styles from './SavedViewsSectionHeader.module.css'

import type { JSX } from 'react'

type SavedViewsSectionHeaderProps = {
  isExpanded: boolean
  onToggle: () => void
  controlsId: string
}

/**
 * Title row for the Views sidebar section. The whole row is the disclosure
 * toggle: hovering highlights the full row and reveals the collapse chevron.
 */
export function SavedViewsSectionHeader({
  isExpanded,
  onToggle,
  controlsId,
}: SavedViewsSectionHeaderProps): JSX.Element {
  const ChevronIcon = isExpanded ? ChevronDownIcon : ChevronRightIcon

  return (
    <button
      type="button"
      className={styles.header}
      onClick={onToggle}
      aria-expanded={isExpanded}
      aria-controls={controlsId}
    >
      <span>Views</span>
      <ChevronIcon size="xsmall" aria-hidden className={styles.chevron} />
    </button>
  )
}
